// stream-upload.service.ts
import { inject, Injectable, NgZone, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { BulkSearchModel } from '@models/BulkSearch';
import { Observable, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BulkSearchService {
  zone=inject(NgZone);
  uploadSubscription!:Subscription;
  bulkSearchStatus=signal('');

  uploadAndStream(formData: FormData): Observable<BulkSearchModel> {
    return new Observable(observer => {
      const controller = new AbortController(); // ✅ controller for abort
      const signal = controller.signal;
      fetch(environment.apiUrl + 'bulkSearch/stream', {
        method: 'POST',
        body: formData,
        signal,
        headers: {
          // Note: DO NOT set 'Content-Type' manually for FormData
          'Accept': 'text/event-stream'
        },
        credentials: 'include'
      }).then(response => {
        const reader = response.body?.getReader();
        const decoder = new TextDecoder('utf-8');

        let buffer = '';
        const read = () => {
          reader?.read().then(({ value, done }) => {
            if (done) {
              observer.complete();
              return;
            }

            const chunk = decoder.decode(value, { stream: true });
            buffer += chunk;

            this.zone.run(() => {
              const lines = buffer.split('\n');
              buffer = lines.pop() || ''; // save the last line in buffer if it's incomplete

              for (const line of lines) {
                if (line.startsWith('data:')) {
                  const jsonStr = line.replace(/^data:\s*/, '');

                  try {
                    const parsed = JSON.parse(jsonStr);
                    observer.next(parsed);
                  } catch (err) {
                    console.error('Invalid JSON in SSE:', jsonStr, err);
                    // Don't emit observer.error — just skip malformed JSON
                  }
                }
              }
            });

            read();
          });
        };
        read();
      }).catch(error => {
        observer.error(error);
      });
        return () => {
          controller.abort(); 
        };
    });
  }
}
